import useMyFetch from "@stores/useMyFetch";
import type { Interview, InterviewObjective } from "@/types";

interface InterviewsResponse {
  interviews: Interview[];
  objectives: InterviewObjective[];
}

export const fetchInterviewByToken = async (surveyToken: string, respondentToken: string, messageId: number | null) => {
  const { response, data } = await useMyFetch(`surveys/${surveyToken}/grids/default/rows/search`)
    .post({ search_bar_input: respondentToken, page: 1, per_page: 14 })
    .json<InterviewsResponse>();
  if (!response.value?.ok) return null;

  const candidates = (data.value?.interviews ?? []).filter((interview) => interview.token === respondentToken);
  const interview =
    candidates.find((candidate) => messageId && candidate.conversation?.some((message) => message.id === messageId)) ??
    candidates[0];
  return interview ? { interview, objectives: data.value?.objectives ?? [] } : null;
};
